import { useMutation, useQueryClient } from '@tanstack/react-query';

import { activateContract } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractActivate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: activateContract,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.contracts._def }),
    });
};
